export const redirect = (url: string) => {
  location.assign(url);

  // return a never resolving promise to wait for location change
  return new Promise(() => undefined as void);
};
